var runtime = require("../../../../../../../../build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"iframe":"_1I5ZE"};
module.exports._getCss = function(wrap, process){return ""+wrap+" ._1I5ZE iframe,"+wrap+" iframe._1I5ZE{display:block;transform:translateZ(0)}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

